import { archives } from './archives';

export const sheets = $axios => ({
  get: (sheetId, params = {}) => $axios.$get(`/sheets/${sheetId}`, { params }),
  update: (sheetId, data = {}) => $axios.$patch(`/sheets/${sheetId}`, data),
  delete: sheetId => $axios.$delete(`/sheets/${sheetId}`),
  // nested resources
  archives: archives($axios),
});
